export const portalMessages = {
  cs: {
    "portal.navigation.open": "Otevřít navigaci",
    "portal.navigation.close": "Zavřít navigaci",
    "portal.navigation.label": "Obsah portálu",
    "portal.navigation.more": "Další",
    "portal.navigation.moreCurrent": "Další – {section}",
    "portal.navigation.allPortals": "Všechny portály",
    "portal.navigation.discover": "Objevovat",
    "portal.navigation.services": "Naše služby",
    "portal.navigation.servicesShort": "Služby",
    "portal.navigation.employees": "Zaměstnanci",
    "portal.navigation.facilities": "Zázemí",
    "portal.navigation.skip": "Přejít na obsah",
    "portal.navigation.backToOverview": "Zpět na přehled",
    "portal.navigation.backToPublicPortal": "Zpět na veřejný portál",
    "portal.title.overview": "Přehled",
    "portal.title.coach": "Můj pokrok",
    "portal.title.bookings": "Moje rezervace",
    "portal.title.reservation": "Rezervovat",
    "portal.title.subscriptions": "Předplatné",
    "portal.title.reviews": "Recenze",
    "portal.title.access": "Vstup do portálu",
    "portal.login": "Přihlásit se",
    "portal.register": "Registrovat se",
    "portal.loginError": "Přihlášení se nepodařilo dokončit. Zkuste to prosím znovu.",
    "portal.logoutError": "Odhlášení se nepodařilo dokončit. Zkuste to prosím znovu.",
    "portal.accountLinkPending": "Osobní obsah se zobrazí, jakmile správce dokončí propojení vašeho účtu.",
    "portal.unavailable.title": "Tato část není dostupná",
    "portal.unavailable.description": "K této části portálu teď nemáte přístup. Vraťte se na přehled nebo kontaktujte provozovatele.",
    "portal.unavailable.signInTitle": "Přihlaste se a pokračujte",
    "portal.unavailable.signInDescription": "Tato část je dostupná přihlášeným klientům portálu. Pokračujte přihlášením ke svému účtu.",
    "portal.unavailable.reviewsSignInTitle": "Recenze jsou pro přihlášené klienty",
    "portal.unavailable.reviewsSignInDescription": "Chcete si přečíst zkušenosti ostatních klientů? Pro zobrazení recenzí se přihlaste ke svému účtu v portálu.",
    "portal.unavailable.membershipTitle": "Připojte se k portálu",
    "portal.unavailable.membershipDescription": "Jste přihlášeni. Pro tuto část ještě potřebujete přístup ke klientskému portálu.",
    "portal.unavailable.membershipAction": "Pokračovat ke vstupu",
    "portal.unavailable.eligibilityTitle": "Tato část vyžaduje další oprávnění",
    "portal.unavailable.eligibilityDescription": "Váš současný přístup tuto část nezahrnuje. Prohlédněte si nabídku předplatného nebo kontaktujte provozovatele.",
    "portal.unavailable.eligibilityAction": "Prohlédnout předplatné",
    "portal.coach.description": "Váš program, cíle a společný pokrok.",
    "portal.subscriptions.title": "Moje předplatné",
    "portal.subscriptions.description": "Přehled plánu přiřazeného vaším poskytovatelem.",
    "portal.subscriptions.catalog": "Nabídka předplatného",
    "portal.subscriptions.catalogDescription": "Prohlédněte si dostupné plány, jejich ceny a výhody.",
    "portal.subscriptions.monthly": "Měsíčně",
    "portal.subscriptions.annual": "Ročně celkem",
    "portal.subscriptions.noPlans": "Poskytovatel zatím nezveřejnil žádné plány předplatného.",
    "portal.subscriptions.select": "Vybrat",
    "portal.subscriptions.selectNamed": "Vybrat balíček {name}",
    "portal.subscriptions.backToPlans": "Zpět na nabídku",
    "portal.subscriptions.unavailablePlan": "Vybraný balíček už není dostupný. Vyberte si z aktuální nabídky.",
    "portal.bookings.description": "Vaše termíny a důležité informace na jednom místě.",
    "portal.poweredBy": "Portál funguje na",
    "portal.access.description": "Váš prostor pro služby a spolupráci. Po přihlášení zde najdete informace, které s vámi poskytovatel sdílí.",
    "portal.access.disabledTitle": "Přihlášení není dostupné",
    "portal.access.invitationTitle": "Máte pozvánku do tohoto portálu",
    "portal.access.title": "Vstoupit do portálu",
    "portal.access.disabledDescription": "Správce tohoto portálu zatím nepovolil přihlašování. Pro přístup se obraťte přímo na něj.",
    "portal.access.invitationDescription": "Přihlaste se pozvaným účtem, nebo si jej vytvořte. Poté můžete pozvánku potvrdit.",
    "portal.access.approvalDescription": "Při první registraci odešlete žádost, kterou schválí správce portálu.",
    "portal.access.registerDescription": "Přihlaste se, nebo si vytvořte svůj účet.",
    "portal.access.existingMembersDescription": "Přihlásit se mohou stávající členové. Pro nový přístup kontaktujte správce.",
    "portal.access.identityDescription": "Pro vstup slouží účet Takeres. Po přihlášení se vrátíte do tohoto portálu.",
    "portal.membership.error.blocked": "Správce pozastavil váš přístup do tohoto portálu.",
    "portal.membership.error.disabled": "Registrace do tohoto portálu je zakázána, a to i na pozvánku.",
    "portal.membership.error.invitationRequired": "Do tohoto portálu potřebujete pozvánku od jeho správce.",
    "portal.membership.error.invalidInvitation": "Pozvánka není platná pro tento portál.",
    "portal.membership.error.expiredInvitation": "Pozvánka vypršela, byla zrušena nebo patří jinému e-mailu. Přihlaste se pozvaným účtem, případně požádejte o novou pozvánku.",
    "portal.membership.error.acceptedInvitation": "Tuto pozvánku již někdo přijal.",
    "portal.membership.error.alreadyLinked": "Zákaznická data jsou již propojena s jiným členstvím. Obraťte se na správce portálu.",
    "portal.membership.error.failed": "Vstup se nepodařilo dokončit. Zkuste to znovu.",
    "portal.membership.blockedTitle": "Přístup je pozastaven",
    "portal.membership.pendingTitle": "Čeká na schválení",
    "portal.membership.rejectedTitle": "Žádost byla zamítnuta",
    "portal.membership.disabledTitle": "Registrace je zakázána",
    "portal.membership.acceptInvitation": "Přijmout pozvánku",
    "portal.membership.title": "Vstoupit do klientského portálu",
    "portal.membership.signedInAs": "Přihlášeno účtem Takeres:",
    "portal.membership.blockedDescription": "Přístup může obnovit správce portálu.",
    "portal.membership.pendingDescription": "Registrace proběhla v pořádku. Jakmile správce schválí váš přístup, můžete portál začít používat.",
    "portal.membership.rejectedDescription": "Správce vaši žádost o vstup neschválil. Pokud se jedná o omyl, obraťte se přímo na něj.",
    "portal.membership.disabledDescription": "Registrace do tohoto portálu je zakázána, a to i na pozvánku. Přihlásit se mohou pouze stávající členové.",
    "portal.membership.invitationRequired": "Tento portál je pouze na pozvánku. Požádejte správce o odkaz pro vstup.",
    "portal.membership.invitationDescription": "Potvrzením přijmete pozvánku do tohoto portálu.",
    "portal.membership.approvalDescription": "Po potvrzení odešlete žádost správci portálu ke schválení.",
    "portal.membership.joinDescription": "Potvrzením se stanete členem tohoto portálu.",
    "portal.membership.busy": "Chvilku…",
    "portal.membership.requestAccess": "Požádat o vstup",
    "portal.membership.switchAccount": "Přihlásit se jiným účtem",
    "portal.membership.logout": "Odhlásit se z portálů",
    "portal.home.bookingAndEventsDescription": "Vyberte si službu nebo událost a rezervujte si svůj termín.",
    "portal.home.bookingDescription": "Vyberte si službu a rezervujte si termín, který vám vyhovuje.",
    "portal.home.eventsDescription": "Prohlédněte si nadcházející události a rezervujte si své místo.",
    "portal.home.reserveAppointment": "Rezervovat termín",
    "portal.home.browseEvents": "Prohlédnout události",
    "portal.home.providerInformation": "Informace o poskytovateli",
    "portal.home.showOnMap": "Zobrazit na mapě",
    "portal.home.searchServices": "Hledat služby",
    "portal.home.serviceUnavailable": "Služba je dočasně nedostupná.",
    "portal.home.duration": "{minutes} min",
    "portal.home.priceOnRequest": "Cena dle domluvy",
    "portal.home.unavailable": "Nedostupné",
    "portal.home.noMatchingServices": "Pro zadaný výraz jsme nenašli žádné služby. Zkuste jiný název, jméno nebo místo.",
    "portal.home.noServices": "Zatím nejsou zveřejněné žádné služby. Zkuste to prosím později.",
    "portal.home.searchEmployees": "Hledat zaměstnance",
    "portal.home.searchFacilities": "Hledat zázemí",
    "portal.home.about": "O nás",
    "portal.home.findUs": "Kde nás najdete",
    "portal.home.contact.address": "Adresa",
    "portal.home.contact.email": "E-mail",
    "portal.home.contact.phone": "Telefon",
    "portal.home.bookResource": "Rezervovat – {name}",
    "portal.home.noMatchingResources": "Pro zadaný výraz jsme v této části nic nenašli. Zkuste jiné jméno, službu nebo místo.",
    "portal.home.upcomingBookings": "Vaše nejbližší termíny",
    "portal.home.searchBookings": "Hledat rezervace",
    "portal.home.noMatchingBookings": "Zadanému hledání neodpovídá žádná rezervace. Zkuste název služby, jméno nebo datum.",
    "portal.home.allBookings": "Všechny rezervace",
    "portal.home.searchResults": "Počet výsledků pro „{query}“: {count} z {total}",
    "portal.search.loading": "Hledání…",
    "portal.search.placeholder": "Hledat…",
    "portal.search.clear": "Vymazat hledání: {label}",
    "portal.share.email": "E-mail",
    "portal.share.label": "Sdílet",
    "portal.share.title": "Sdílet přes",
    "portal.share.close": "Zavřít sdílení",
    "portal.share.options": "Možnosti sdílení",
    "portal.share.channel": "Sdílet přes {channel}",
    "portal.share.copyAlternative": "Nebo zkopírujte odkaz",
    "portal.share.copiedLabel": "Odkaz zkopírován",
    "portal.share.copy": "Kopírovat odkaz",
    "portal.share.copied": "Odkaz byl zkopírován.",
    "portal.share.manualCopy": "Odkaz je označený. Zkopírujte jej pomocí nabídky zařízení nebo kláves Ctrl+C / ⌘C.",
    "portal.share.copying": "Kopírování…",
    "portal.map.namedTitle": "Mapa – {name}",
    "portal.map.title": "Mapa místa",
    "portal.map.loading": "Načítání mapy…",
    "portal.map.unavailable": "Náhled mapy pro tento odkaz není dostupný. Místo si můžete otevřít přímo na mapě.",
    "portal.map.addressFallback": "Mapa podle uvedené adresy",
    "portal.map.directions": "Najděte k nám cestu",
    "portal.map.open": "Otevřít mapu",
    "portal.reviews.countOne": "{count} recenze",
    "portal.reviews.countFew": "{count} recenze",
    "portal.reviews.countMany": "{count} recenzí",
    "portal.reviews.summary": "Hodnocení {rating} z 5, {reviews}. Zobrazit recenze.",
    "portal.reviews.unrated": "Zatím bez hodnocení. Napište první recenzi.",
    "portal.reviews.show": "Zobrazit recenze",
    "portal.reviews.loading": "Načítání hodnocení…",
    "portal.reviews.writeFirst": "Napište první recenzi",
  },
  en: {
    "portal.navigation.open": "Open navigation",
    "portal.navigation.close": "Close navigation",
    "portal.navigation.label": "Portal navigation",
    "portal.navigation.more": "More",
    "portal.navigation.moreCurrent": "More – {section}",
    "portal.navigation.allPortals": "All portals",
    "portal.navigation.discover": "Discover",
    "portal.navigation.services": "Our services",
    "portal.navigation.servicesShort": "Services",
    "portal.navigation.employees": "Staff",
    "portal.navigation.facilities": "Facilities",
    "portal.navigation.skip": "Skip to content",
    "portal.navigation.backToOverview": "Back to overview",
    "portal.navigation.backToPublicPortal": "Back to public portal",
    "portal.title.overview": "Overview",
    "portal.title.coach": "My progress",
    "portal.title.bookings": "My bookings",
    "portal.title.reservation": "Book now",
    "portal.title.subscriptions": "Subscriptions",
    "portal.title.reviews": "Reviews",
    "portal.title.access": "Portal access",
    "portal.login": "Sign in",
    "portal.register": "Create account",
    "portal.loginError": "Sign-in could not be completed. Please try again.",
    "portal.logoutError": "Sign-out could not be completed. Please try again.",
    "portal.accountLinkPending": "Your personal content will appear once the administrator finishes linking your account.",
    "portal.unavailable.title": "This section is unavailable",
    "portal.unavailable.description": "You don’t currently have access to this section. Return to the overview or contact the provider.",
    "portal.unavailable.signInTitle": "Sign in to continue",
    "portal.unavailable.signInDescription": "This section is available to signed-in portal clients. Sign in to your account to continue.",
    "portal.unavailable.reviewsSignInTitle": "Reviews are for signed-in clients",
    "portal.unavailable.reviewsSignInDescription": "Want to read other clients’ experiences? Sign in to your portal account to view the reviews.",
    "portal.unavailable.membershipTitle": "Join this portal",
    "portal.unavailable.membershipDescription": "You are signed in. You still need access to this client portal to view this section.",
    "portal.unavailable.membershipAction": "Continue to portal access",
    "portal.unavailable.eligibilityTitle": "Additional access is required",
    "portal.unavailable.eligibilityDescription": "Your current access does not include this section. Explore the subscription plans or contact the provider.",
    "portal.unavailable.eligibilityAction": "Explore subscriptions",
    "portal.coach.description": "Your programme, goals and shared progress.",
    "portal.subscriptions.title": "My subscriptions",
    "portal.subscriptions.description": "An overview of the plan assigned by your provider.",
    "portal.subscriptions.catalog": "Subscription plans",
    "portal.subscriptions.catalogDescription": "Explore the available plans, prices and benefits.",
    "portal.subscriptions.monthly": "Monthly",
    "portal.subscriptions.annual": "Annual total",
    "portal.subscriptions.noPlans": "The provider has not published any subscription plans yet.",
    "portal.subscriptions.select": "Select",
    "portal.subscriptions.selectNamed": "Select the {name} plan",
    "portal.subscriptions.backToPlans": "Back to plans",
    "portal.subscriptions.unavailablePlan": "The selected plan is no longer available. Choose from the current plans.",
    "portal.bookings.description": "Your appointments and important information in one place.",
    "portal.poweredBy": "Powered by",
    "portal.access.description": "Your space for services and collaboration. Sign in to see the information your provider shares with you.",
    "portal.access.disabledTitle": "Sign-in is unavailable",
    "portal.access.invitationTitle": "You have an invitation to this portal",
    "portal.access.title": "Enter portal",
    "portal.access.disabledDescription": "This portal’s administrator has not enabled sign-in yet. Contact them directly for access.",
    "portal.access.invitationDescription": "Sign in with the invited account, or create it. You can then accept the invitation.",
    "portal.access.approvalDescription": "Your first registration sends a request for the portal administrator to approve.",
    "portal.access.registerDescription": "Sign in or create your account.",
    "portal.access.existingMembersDescription": "Existing members can sign in. Contact the administrator to request access.",
    "portal.access.identityDescription": "Use your Takeres account to enter. After signing in, you will return to this portal.",
    "portal.membership.error.blocked": "The administrator has suspended your access to this portal.",
    "portal.membership.error.disabled": "Registration for this portal is disabled, including by invitation.",
    "portal.membership.error.invitationRequired": "You need an invitation from the administrator to join this portal.",
    "portal.membership.error.invalidInvitation": "This invitation is not valid for this portal.",
    "portal.membership.error.expiredInvitation": "The invitation has expired, was cancelled or belongs to another email address. Sign in with the invited account or request a new invitation.",
    "portal.membership.error.acceptedInvitation": "This invitation has already been accepted.",
    "portal.membership.error.alreadyLinked": "The customer data is already linked to another membership. Contact the portal administrator.",
    "portal.membership.error.failed": "Access could not be completed. Please try again.",
    "portal.membership.blockedTitle": "Access suspended",
    "portal.membership.pendingTitle": "Awaiting approval",
    "portal.membership.rejectedTitle": "Request rejected",
    "portal.membership.disabledTitle": "Registration disabled",
    "portal.membership.acceptInvitation": "Accept invitation",
    "portal.membership.title": "Enter client portal",
    "portal.membership.signedInAs": "Signed in with Takeres account:",
    "portal.membership.blockedDescription": "The portal administrator can restore your access.",
    "portal.membership.pendingDescription": "Registration was successful. You can start using the portal once the administrator approves your access.",
    "portal.membership.rejectedDescription": "The administrator did not approve your access request. Contact them directly if this was a mistake.",
    "portal.membership.disabledDescription": "Registration for this portal is disabled, including by invitation. Only existing members can sign in.",
    "portal.membership.invitationRequired": "This portal is invitation-only. Ask the administrator for an access link.",
    "portal.membership.invitationDescription": "Confirm to accept your invitation to this portal.",
    "portal.membership.approvalDescription": "Confirm to send an access request to the portal administrator.",
    "portal.membership.joinDescription": "Confirm to become a member of this portal.",
    "portal.membership.busy": "Please wait…",
    "portal.membership.requestAccess": "Request access",
    "portal.membership.switchAccount": "Sign in with another account",
    "portal.membership.logout": "Sign out of portals",
    "portal.home.bookingAndEventsDescription": "Choose a service or event and reserve your appointment.",
    "portal.home.bookingDescription": "Choose a service and book a time that works for you.",
    "portal.home.eventsDescription": "Explore upcoming events and reserve your place.",
    "portal.home.reserveAppointment": "Book an appointment",
    "portal.home.browseEvents": "Explore events",
    "portal.home.providerInformation": "Provider information",
    "portal.home.showOnMap": "Show on map",
    "portal.home.searchServices": "Search services",
    "portal.home.serviceUnavailable": "This service is temporarily unavailable.",
    "portal.home.duration": "{minutes} min",
    "portal.home.priceOnRequest": "Price on request",
    "portal.home.unavailable": "Unavailable",
    "portal.home.noMatchingServices": "No services match your search. Try another service, name or location.",
    "portal.home.noServices": "No services have been published yet. Please try again later.",
    "portal.home.searchEmployees": "Search staff",
    "portal.home.searchFacilities": "Search facilities",
    "portal.home.about": "About us",
    "portal.home.findUs": "Find us",
    "portal.home.contact.address": "Address",
    "portal.home.contact.email": "Email",
    "portal.home.contact.phone": "Phone",
    "portal.home.bookResource": "Book – {name}",
    "portal.home.noMatchingResources": "No matches in this section. Try another name, service or location.",
    "portal.home.upcomingBookings": "Your upcoming appointments",
    "portal.home.searchBookings": "Search bookings",
    "portal.home.noMatchingBookings": "No bookings match your search. Try a service name, person or date.",
    "portal.home.allBookings": "All bookings",
    "portal.home.searchResults": "Results for “{query}”: {count} of {total}",
    "portal.search.loading": "Searching…",
    "portal.search.placeholder": "Search…",
    "portal.search.clear": "Clear search: {label}",
    "portal.share.email": "Email",
    "portal.share.label": "Share",
    "portal.share.title": "Share via",
    "portal.share.close": "Close sharing",
    "portal.share.options": "Sharing options",
    "portal.share.channel": "Share via {channel}",
    "portal.share.copyAlternative": "Or copy the link",
    "portal.share.copiedLabel": "Link copied",
    "portal.share.copy": "Copy link",
    "portal.share.copied": "The link has been copied.",
    "portal.share.manualCopy": "The link is selected. Copy it using your device menu or Ctrl+C / ⌘C.",
    "portal.share.copying": "Copying…",
    "portal.map.namedTitle": "Map – {name}",
    "portal.map.title": "Location map",
    "portal.map.loading": "Loading map…",
    "portal.map.unavailable": "A preview is unavailable for this link. You can open the location directly on the map.",
    "portal.map.addressFallback": "Map based on the listed address",
    "portal.map.directions": "Get directions",
    "portal.map.open": "Open map",
    "portal.reviews.countOne": "{count} review",
    "portal.reviews.countFew": "{count} reviews",
    "portal.reviews.countMany": "{count} reviews",
    "portal.reviews.summary": "Rated {rating} out of 5, {reviews}. View reviews.",
    "portal.reviews.unrated": "No ratings yet. Write the first review.",
    "portal.reviews.show": "View reviews",
    "portal.reviews.loading": "Loading ratings…",
    "portal.reviews.writeFirst": "Write the first review",
  },
};
